import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EntityStatus } from "src/app/shared/constants/entity-status";
import { environment } from "src/environments/environment";
import { ICountry, ICreateCountry, IUpdateCountry } from "../models/country.model";
import { PaginatedResponseModel, ResponseModel } from "src/app/shared/interfaces/response-model";

@Injectable({
    providedIn: 'root'
})
export class CountryService {
    private http = inject(HttpClient);
    private readonly baseUrl = `${environment.cmsBaseUrl}/api/${environment.anqCmsVersion}/Countries`;
    
    createCountry(payload: ICreateCountry): Observable<ResponseModel<any>> {
        return this.http.post<ResponseModel<any>>(`${this.baseUrl}/CreateCountry`, payload);
    }

    getPaginatedCountries(query?: {
            countryCode?: string;
            mobileCountryCode?: string;
            mobileCountryCodeList?: string[];
            entityStatus?: EntityStatus;
            iso?: string;
            countryName?: string;
            page?: number;
            pageSize?: number;
            from?: Date;
            to?: Date;
            sortBy?: string;
            isAscending?: boolean;
            totalPages?: number;
            search?: string;
    }): Observable<PaginatedResponseModel<ICountry[]>> {
        let params = new HttpParams();
        if (query) {
            if (query.countryCode) params = params.set('CountryCode', query.countryCode);
            if (query.mobileCountryCode) params = params.set('MobileCountryCode', query.mobileCountryCode);
            if (query.mobileCountryCodeList) params = params.set('MobileCountryCodeList', query.mobileCountryCodeList.join(','));
            if (query.entityStatus) params = params.set('EntityStatus', query.entityStatus);
            if (query.iso) params = params.set('ISO', query.iso);
            if (query.countryName) params = params.set('CountryName', query.countryName);
            if (query.page) params = params.set('Page', query.page);
            if (query.pageSize) params = params.set('PageSize', query.pageSize);
            if (query.from) params = params.set('From', query.from.toISOString());
            if (query.to) params = params.set('To', query.to.toISOString());
            if (query.sortBy) params = params.set('SortBy', query.sortBy);
            if (query.isAscending) params = params.set('IsAscending', query.isAscending);
            if (query.totalPages) params = params.set('TotalPages', query.totalPages);
            if (query.search) params = params.set('Search', query.search);
        }
        return this.http.get<PaginatedResponseModel<ICountry[]>>(`${this.baseUrl}/GetPaginatedCountries`, {
            params
        });
    }

    getCountryById(countryId: string): Observable<ResponseModel<ICountry>> {
        let params = new HttpParams();
        if (countryId) params = params.set('CountryId', countryId);

        return this.http.get<ResponseModel<ICountry>>(`${this.baseUrl}/GetCountryById`, {
            params
        });
    }
    
    updateCountry(id: string, payload: IUpdateCountry, status?: EntityStatus): Observable<ResponseModel<any>> {
        let params = new HttpParams();
        if (status) params = params.set('Status', status);

        return this.http.put<ResponseModel<any>>(`${this.baseUrl}/UpdateCountry/${id}`,
            payload,
            { params }
        );
    }
}